<div class="skills py-5" id="skills">
  <div class="container d-flex flex-column align-items-center gap-4">
    <div class="row w-100 gap-4">
      <div class="col-12 d-flex flex-column align-items-center gap-2">
        <h2 class="text-light fw-bold">My Skills</h2>
        <div class="underline"></div>
      </div>
      <div class="col-12">
        <p class="text-center skills-subtitle">
          Here are my technical skills and expertise that I've developed and
          honed over the years.
        </p>
      </div>
    </div>

    <div class="w-100 justify-content-between skill-section gap-4">
      <div class="skill-card">
        <div class="skill-title d-flex gap-3">
          <img src="assets/images/svg/web.svg" class="skill-icon" alt="web-icon" />
          <h5 class="m-0 section-title">Frontend Development</h5>
        </div>
        @for (fe of feSkills; track $index) {
          <app-progress-bar [config]="{percent: fe.percent, title: fe.title}"></app-progress-bar>
        }
      </div>
      <div class="skill-card">
        <div class="skill-title d-flex gap-3">
          <img
            src="assets/images/svg/datastore.svg"
            class="skill-icon"
            alt="datastore"
          />
          <h5 class="m-0 section-title">Backend Development</h5>
        </div>
        @for (be of beSkills; track $index) {
          <app-progress-bar [config]="{percent: be.percent, title: be.title}"></app-progress-bar>
        }
      </div>
      <div class="skill-card">
        <div class="skill-title d-flex gap-3">
          <img src="assets/images/svg/database.svg" class="skill-icon" alt="database" />
          <h5 class="m-0 section-title">Database</h5>
        </div>
        @for (db of dbSkills; track $index) {
          <app-progress-bar [config]="{percent: db.percent, title: db.title}"></app-progress-bar>
        }
      </div>
      <div class="skill-card">
        <div class="skill-title d-flex gap-3">
          <img src="assets/images/svg/bulb.svg" class="skill-icon" alt="bulb" />
          <h5 class="m-0 section-title">Other Skills</h5>
        </div>
        @for (skill of otherSkills; track $index) {
          <app-progress-bar [config]="{percent: skill.percent, title: skill.title}"></app-progress-bar>
        }
      </div>
    </div>
  </div>
</div>
